// @flow

import get from 'lodash/get';
import { FEEDBACK_STATE } from '../constants';
import type { UserState } from './types';

export const userIdSelector = (state: Object): string => {
  const feedbackState: UserState = state[FEEDBACK_STATE];
  return get(feedbackState, 'user.userId', null);
};



// WEBPACK FOOTER //
// ./app/CaptureFeedback/user/selectors.js